import { useMemo } from 'react';
import { createApiCall, useDashboardData } from '@/hooks/useDashboardData';
import { getAdminMeetingsCard } from '@/api/meetingService';
import type { RawMeeting } from '@/pages/MeetingDashboard/MeetingDashboard';

import { isMeetingRecorded } from '@/utils/meetingFilter';

const extractMeetingList = (payload: any): any[] => {
  if (!payload) return [];
  const root = payload.data ?? payload;
  if (Array.isArray(root)) return root;
  if (Array.isArray(root.allMeetings)) return root.allMeetings;
  if (Array.isArray(root.items)) return root.items;
  if (Array.isArray(root.data)) return root.data;
  return [];
};

const extractTenantUsers = (payload: any): any[] => {
  if (!payload) return [];
  const root = payload.data ?? payload;
  const users = root.tenantsUsers?.items ?? root.tenantsUsers ?? [];
  return Array.isArray(users) ? users : [];
};

export const useMeetingDashboardData = () => {
  const apiCalls = [
    createApiCall('meetings', () => getAdminMeetingsCard({ view: 'list', page: 1, pageSize: 1000 }))
  ];

  const { data, isLoading, isError, errors, refetchAll, refetchByKey } = useDashboardData(apiCalls);

  const rawMeetings = useMemo<RawMeeting[]>(
    () => extractMeetingList(data?.meetings).filter(isMeetingRecorded),
    [data?.meetings],
  );

  const tenantUsers = useMemo<any[]>(
    () => extractTenantUsers(data?.meetings),
    [data?.meetings],
  );

  return {
    rawMeetings,
    tenantUsers,
    isLoading,
    isError,
    errors,
    refetchAll,
    refetchByKey,
  };
};
